<template>
    <v-card :elevation="elevation" max-width="600">
        <v-card-text v-if="loading" class="text-center">
            <v-icon >mdi-loading mdi-spin</v-icon>
        </v-card-text>
        <v-card-text v-else-if="helpText" class="py-6 text-white text-body-2" v-html="helpText.text"></v-card-text>
        <v-toolbar flat dark color="pink" max-height="64">
            <v-toolbar-title class="text-subtitle-1 font-weight-bold">Gesprek checklist</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="close" icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
    </v-card>
</template>

<script>
import AbstractNotification from "@/components/General/PushNotification/AbstractNotification";
import InternalHelpText from "@/models/InternalHelpText/InternalHelpText";

export default {
    extends: AbstractNotification,
    data() {
        return {
            helpText: null,
            loading: true,
        }
    },
    methods: {
        async loadHelpText() {
            this.helpText = await InternalHelpText.api().where('key', 'phonecall-questions').first();
        }
    },
    created() {
        this.loadHelpText().then(() => {
            this.loading = false;
        });
    }
}
</script>
